import axiosInstance from "../axios/axiosTokenMiddleware";
import { baseUrl, uploadFile, mode, role, version } from "../config/config";
import { upload } from "@testing-library/user-event/dist/upload";

// Create a function to generate the upload URL based on category

const uploadUrl = (category) =>
  `${baseUrl}${version}${mode}${role}${category}/${uploadFile}`;

export const uploadImageRequest = async (file, category) => {
  const formData = new FormData();
  formData.append("uploaded_file", file);

  try {
    const url = uploadUrl(category);
    const response = await axiosInstance.post(url, formData);

    return {
      success: true,
      code: response.data.code, // very important
      data: response.data.data || [],
      message: response.data.message?.displayMessage,
    };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data?.message?.displayMessage || "Upload failed",
    };
  }
};
